import { ABTests } from '../../stores/abTestStore';

export const getABTests = async () => {
  return {
    'collect-phone-company-for-smb-feature': {
      entityId: 'default',
      featureName: 'collect-phone-company-for-smb-feature',
      result: 'v1',
    },
  } as ABTests;
};

export interface Metric {
  metricsKey: string;
  metricsValue: number;
}

interface MetricsBody {
  entityId: string;
  metricsArray: Metric[];
}

export const sendABMetrics = async (_data: MetricsBody) => {
  return true;
};
